import { createApp } from "vue";
import App from "./App.vue";
import MonsterPlayer from "./components/MonsterPlayer.vue";
const app = createApp(App);
app.component("monster-player", MonsterPlayer);
app.mount("#app");
